import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { DatosFacturacionService } from "../../shared/datos-facturacion.service";
import { CFDI } from "../../entities/cdfi";
import { RFiscal } from "../../entities/regimenFiscal";
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-facturacion-externa-datos',
  templateUrl: './facturacion-externa-datos.component.html',
  styleUrls: ['./facturacion-externa-datos.component.scss']
})
export class FacturacionExternaDatosComponent implements OnInit {
  public idDatoFactura: number;
  public idDireccion: number;
  public facturacionForm: FormGroup;
  public listaCfdi: CFDI[];
  public listaRegimenFiscal: RFiscal[];
  public title = 'Registrar'
  public tipoPersona = 'moral'
  constructor(
    private datosFactService: DatosFacturacionService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {    
    this.initForm();    
    // Swal.fire({
    //   text: "Cargando datos de facturación",
    //   allowOutsideClick: false,
    //   showConfirmButton: false,
    //   onBeforeOpen: () => {
    //     Swal.showLoading();
    //   },
    //   customClass: {
    //     container: "custom-swal-height",
    //   },
    // });
  
    this.route.params.subscribe((param) => {
      this.idDatoFactura = param["idOrden"];
      this.idDireccion = param["idDireccion"];
    
      this.obtenerCFDIyRF().subscribe(() => {});
    });
  }
  

  // obtenerDatos(id: number) {
  //   this.datosFactService.obtenerDatosById(id).subscribe(
  //     (response) => {
  //       console.log(response.regimenFiscal);
        
  //       // Aquí, las listas ya están cargadas, por lo que podemos usarlas
  //       this.facturacionForm.patchValue({
  //         rfc: response.rfc,
  //         nombre: response.nombre,
  //         cp: response.cp,
  //         regimenFiscal: this.listaRegimenFiscal.find(rf => rf.valor == response.regimenFiscal),
  //         usoCfdi: this.listaCfdi.find(cfdi => cfdi.usoCFDI === response.usoCfdi)
  //       });
  
  //       Swal.close();
  //     },
  //     (error) => {
  //       console.error('Error fetching data', error);
  //       Swal.close();
  //     }
  //   );
  // }
  



  obtenerCFDIyRF() {
    return forkJoin({
      cfdi: this.datosFactService.listarCFDI(),
      regimenFiscal: this.datosFactService.listarRegimenFiscal()
    }).pipe(
      tap(({ cfdi, regimenFiscal }) => {
        this.listaCfdi = cfdi;
        this.listaRegimenFiscal = regimenFiscal;
      })
    );
  }
  

  initForm() {
    this.facturacionForm = this.fb.group({
      id: '',
      rfc: new FormControl("", [
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])(?=.*\d).+$/),
        Validators.maxLength(16),
      ]),
      // referencia: new FormControl("", [Validators.required]),
      nombre: new FormControl(""),
      razonSocial: new FormControl("", [Validators.required]),
      apellidoPaterno: new FormControl(""),
      apellidoMaterno: new FormControl(""),
      tipoPersona: new FormControl("moral", [Validators.required]),
      cp: new FormControl("", [Validators.required]),
      telefono: new FormControl("", [Validators.required]),
      correo: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ]),
      regimenFiscal: new FormControl("", [Validators.required]),
      usoCfdi: new FormControl("", [Validators.required]),
    });
  }


  soloLetrasNumerosExt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9]/g, "");
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }

  soloLetrasNumerosEspacios(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9\s]/g, ""); // Incluye \s para espacios
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }

  soloNumerosDomFisc(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ cp: soloNumeros });
  }

  soloNumerosTelf(event: any): void {
    const input = event.target as HTMLInputElement;
    let soloNumeros = input.value.replace(/[^0-9]/g, "");
    if (soloNumeros.length > 10) {
      soloNumeros = soloNumeros.substring(0, 10);
    }
    this.facturacionForm.patchValue({ telefono: soloNumeros });
  }
  

  soloNumerosRegimenFiscal(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ regimenFiscal: soloNumeros });
  }



  changeCdfi() {
    //console.log('aca');
  }

  changeRf() {
    //console.log('aca');
  }

  guardar() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Para un desplazamiento suave
    });
    if (this.facturacionForm.invalid) {
      this.facturacionForm.markAllAsTouched();
      this.toastr.error("Debes completar todos los campos");
    
      const invalidControls = [];
      const controls = this.facturacionForm.controls;
    
      for (const name in controls) {
        if (controls[name].invalid) {
          invalidControls.push(name);
        }
      }
    
      console.warn("Controles inválidos:", invalidControls);
    
    } else {
      const control = this.facturacionForm.controls;
      const data: any = {
        rfc: control.rfc.value,
        cp: control.cp.value,
        regimenFiscal: control.regimenFiscal.value.valor,
        usoCfdi: control.usoCfdi.value.usoCFDI,
        correo: control.correo.value,
        tipoPersona: control.tipoPersona.value === 'moral' ? 2 : 1,
        telefono: control.telefono.value,
        esInvitado: true,
        idDireccion: this.idDireccion,
        idOrden: this.idDatoFactura
      };
      
      if (control.tipoPersona.value === 'moral') {
        data.nombre = control.razonSocial.value;
        data.apellidoMaterno = control.apellidoMaterno.value;
        data.apellidoPaterno = control.apellidoPaterno.value;
        console.log(2);
        
        // this.datosFactService
        //   .actualizarDatos(data)
        //   .subscribe(
        //     (success) => {
        //       this.volver();
        //       Swal.fire({
        //         title: "¡Operación exitosa!",
        //         html: `¡Se han modificado de manera exitosa los datos!`,
        //         icon: "success",
        //         confirmButtonColor: "#3085d6",
        //         confirmButtonText: "Confirmar",
        //       });
        //     },
        //     (error) => {
        //       Swal.fire({
        //         title: "¡Ops!",
        //         text: `¡Error al intentar actualizar los datos!`,
        //         icon: "warning",
        //         confirmButtonColor: "#3085d6",
        //         confirmButtonText: "Confirmar",
        //         // onClose: () => {
        //         //   this.router.navigateByUrl('pages/datos-facturacion')
        //         // }
        //       });
        //     }
        //   );

      } else {
        data.nombre = control.nombre.value;
        data.apellidoMaterno = null;
        data.apellidoPaterno = null;
        // this.datosFactService.guardarDatos(data).subscribe(
        //   (result: any) => {
        //     Swal.fire({
        //       title: "Datos Guardados!",
        //       text: "Los datos han sido guardados con éxito.",
        //       icon: "success",
        //       confirmButtonText: 'Aceptar',
        //       onClose: () => {
        //         this.router.navigateByUrl('pages/datos-facturacion')
        //       }
        //     });
        //   },
        //   (err) => {
        //     Swal.fire({
        //       title: "¡Ops!",
        //       text: err.error,
        //       icon: "error",
        //       confirmButtonText: "Cerrar"
        //     });
        //   }
        // );
      }

      console.log(data);
    }
  }

  compareCfdi(c1: CFDI, c2: CFDI): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  compareRf(rf1: CFDI, rf2: CFDI): boolean {
    return rf1 && rf2 ? rf1.id === rf2.id : rf1 === rf2;
  }

  changeTipoPersona(): void {
    const tipoSeleccionado = this.facturacionForm.get('tipoPersona')?.value;
  
    // Guardamos el valor en una propiedad si la necesitas
    this.tipoPersona = tipoSeleccionado;
  
    if (tipoSeleccionado === 'moral') {
      // Desactivar validación para nombre, apellidos
      this.facturacionForm.get('nombre')?.clearValidators();
      this.facturacionForm.get('apellidoPaterno')?.clearValidators();
      this.facturacionForm.get('apellidoMaterno')?.clearValidators();
  
      // Activar validación para razón social
      this.facturacionForm.get('razonSocial')?.setValidators([Validators.required]);
    } else {
      // Activar validación para nombre, apellidos
      this.facturacionForm.get('nombre')?.setValidators([Validators.required]);
      this.facturacionForm.get('apellidoPaterno')?.setValidators([Validators.required]);
      this.facturacionForm.get('apellidoMaterno')?.setValidators([Validators.required]);
  
      // Desactivar validación para razón social
      this.facturacionForm.get('razonSocial')?.clearValidators();
    }
  
    // Importante: Actualizar estado de validación
    this.facturacionForm.get('nombre')?.updateValueAndValidity();
    this.facturacionForm.get('apellidoPaterno')?.updateValueAndValidity();
    this.facturacionForm.get('apellidoMaterno')?.updateValueAndValidity();
    this.facturacionForm.get('razonSocial')?.updateValueAndValidity();
  }
  

  volver() {
    // this.router.navigate(["/pages/datos-facturacion"]);
  }
}
